import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";

import { useNotification } from "../../components/notification";
import apiService from "../../services/apiService";
import { useAuth } from "../../contexts/authContext";

import ManageAddress from "./_manage";

const Address = () => {
  const { showNotification } = useNotification();
  const { user } = useAuth();

  const [addresses, setAddresses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState({ PageNumber: 1, PageSize: 25 });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchAddresses = async () => {
      setIsLoading(true);
      try {
        const response = await apiService.get(`/addresses`, {
          page: page.PageNumber,
          limit: page.PageSize,
          search: searchTerm,
        });
        setAddresses(response.addresses);
        setTotalRecords(response.pagination.total);
      } catch (error) {
        showNotification("danger", error || "Failed to get address.", 5000);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAddresses();
  }, [page, searchTerm, showNotification]);

  // Handle page change
  const handlePageChange = (pageNumber, pageSize) => {
    setPage({ PageNumber: pageNumber, PageSize: pageSize });
  };

  // Handle search term
  const handleSearchTerm = (text) => {
    setSearchTerm(text);
    setPage({ PageNumber: 1, PageSize: page.PageSize }); // Reset to the first page
  };

  return (
    <Card className="p-4 rounded-4">
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between">
          <h1 className="mb-1 fs-5">Manage Addresses</h1>
        </div>
        <p className="mb-0 text-light-emphasis fw-light">
          Ensure addresses are linked to the account.
        </p>
        <hr className="my-3" />
        <ManageAddress
          addresses={addresses}
          setAddresses={setAddresses}
          totalRecords={totalRecords}
          page={page}
          handlePageChange={handlePageChange}
          handleSearchTerm={handleSearchTerm}
          showNotification={showNotification}
          isLoading={isLoading}
          isAdminView={true}
          userRole={user?.role}
        />
      </Card.Body>
    </Card>
  );
};

export default Address;
